import { apiCIMToolkitUrl } from "../../configuration";
import axios from "axios";

export const getAnalysis = async (resourceID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/resource/analysis`,
    data: {
      resourceID: resourceID,
      token: token
    }
  });
  return response;
}

export const getProject = async (projectID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project`,
    data: {
      projectID: projectID,
      token: token
    }
  });
  return response;
};

export const getProjects = async (token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/projects`,
    data: {
      token: token
    }
  });
  return response;
};

export const getProjectResources = async (projectID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project/resources`,
    data: {
      id: projectID,
      token: token
    }
  });
  return response;
};

export const getProjectSites = async (projectID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project/sites`,
    data: {
      id: projectID,
      token: token
    }
  });
  return response;
};

export const createProject = async (projectData, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project/create`,
    data: {
      name: projectData.name,
      description: projectData.description,
      latitude: projectData.latitude,
      longitude: projectData.longitude,
      locationMapZoomLevel: projectData.locationMapZoomLevel,
      token: token
    }
  });
  return response;
};

export const createProjectResource = async (resourceData, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project/resource/create`,
    data: {
      name: resourceData.name,
      projectID: resourceData.projectID,
      type: resourceData.type,
      token: token
    }
  });
  return response;
};

export const deleteProject = async (id, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project/delete`,
    data: {
      id: id,
      token: token
    }
  });
  return response;
};

export const editProject = async (projectData, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/project/edit`,
    data: {
      id: projectData.id,
      name: projectData.name,
      description: projectData.description,
      latitude: projectData.latitude,
      longitude: projectData.longitude,
      locationMapZoomLevel: projectData.locationMapZoomLevel,
      token: token
    }
  });
  return response;
};

export const getResourceDownloadToken = async (resourceID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/resource/download`,
    data: {
      resourceID: resourceID,
      token: token
    }
  });
  return response;
};

export const getResourceUploadToken = async (resourceID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/resource/upload`,
    data: {
      resourceID: resourceID,
      token: token
    }
  });
  return response;
};

export const deleteResource = async (resourceID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/resource/delete`,
    data: {
      resourceID: resourceID,
      token: token
    }
  });
  return response;
};

export const updateResourceFileSize = async (resourceID, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/resource/updateFileSize`,
    data: {
      resourceID: resourceID,
      token: token
    }
  });
  return response;
};

export const getLibraryCategories = async token => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/library/categories`,
    data: {
      token: token
    }
  });
  console.log("getLibraryCategories > response", response)
  return response;
}

export const getLibraryItems = async (categoryID, token) => {
  console.log("Getting library items. token: ", token)
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/library/items`,
    data: {
      categoryID: categoryID,
      token: token
    }
  });
  console.log("Response: ", response.data)
  return response;
}

export const searchLibraryItems = async (searchTerms, token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/library/search`,
    data: {
      searchTerms: searchTerms,
      token: token
    }
  });
  return response;
}

export const getQuota = async (token) => {
  const response = await axios({
    method: "post",
    url: `${apiCIMToolkitUrl}/quotaUsed`,
    data: {
      token: token
    }
  });
  return response;
};
